import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import { merge, get, clone, set, findIndex } from 'lodash';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Icon, InputItem } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { getSportList, handleImgData } from './action';
import { VBottomNav } from '../../../components/copyright/common';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { base64ToBlob, blobToFile, readCookie } from '../../../utils/common';
import { HeaderImages } from '../../../components/copyright/headerImages';
import { Vh5Bar } from '../../../components/bar';
// import Tloader from 'react-touch-loader';
import Tloader from '../../../components/loader';
import LazyLoad from 'vanilla-lazyload';
import { Vh5Video } from '../../../components/videoPaler';
import { _track } from '../../../utils/track';
import './index.scss';
const mapStateToProps = state => {
	return {
		totalCount: state.CopyrightEventsReducers.totalCount,
		pageIndex: state.CopyrightEventsReducers.pageIndex,
		pageSize: state.CopyrightEventsReducers.pageSize,
		sportList: state.CopyrightEventsReducers.sportList
	};
};
let lazyLoadInstance = null;
function CopyrightEvents(props) {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { sportList = [], totalCount, pageIndex, pageSize } = useMappedState(mapState);
	console.log('sportList.....', sportList);
	let [effectFlag, setEffectFlag] = useState(1);
	let [playerOptions, setPlayerOptions] = useState({});
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let dispatch = useDispatch();
	let handleLoadMore = resolve => {
		console.log('loading.....');
		console.log('pageSize', totalCount, pageIndex, pageSize);
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		dispatch(
			getSportList(
				{
					index: pageIndex + 1,
					limit: pageSize,
					sort: -1
				},
				data => {
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_events_page',
						payload: {
							page_action_name: 'events-tploader-sportlist'
						}
					});
					resolve();
				}
			)
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	const actTypeIcons = {
		1: {
			iconFn: <i className={'iconfont public-benefit'}>&#xe662;</i>,
			text: '公益活动',
			className: 'public-benefit'
		},
		2: {
			iconFn: <i className={'iconfont reward'}>&#xe665;</i>,
			text: '悬赏活动',
			className: 'reward'
		},
		3: {
			iconFn: <i className={'iconfont flash'}>&#xe66b;</i>,
			text: '快闪活动',
			className: 'flash'
		}
	};
	function ActTypeIcon(prop) {
		let item = prop.item;
		let category = item.category;
		if (!category) {
			return '';
		}
		let type = actTypeIcons[category];
		return (
			<span className="act-type">
				{actTypeIcons[item.category].iconFn}
				<span className="text">{actTypeIcons[item.category].text}</span>
			</span>
		);
	}
	function toActivity(item) {
		//处理微信授权的问题 通过history.push 方式会导致打开activity分享空白
		_track({
			trackName: 'toutu_events_page',
			payload: {
				id: item.id,
				page_action_name: 'events-location-activity'
			}
		});
		window.location.href = '/vpmobile/copyright/activity/' + item.id + '/events';
	}
	function remainDaysTip(timestamp) {
		let ms = timestamp - new Date().getTime();
		if (ms <= 0) {
			return '活动已结束';
		}
		return `活动将于${Math.ceil(ms / 1000 / 3600 / 24)}天后结束`;
	}
	useEffect(() => {
		console.log(cache, effectFlag, sportList);
		if (!cache || (effectFlag === 1 && sportList.length === 0)) {
			setCache(true);
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 300
				// ... more custom settings?
			});
			dispatch(
				getSportList({ index: 1, limit: 5 }, data => {
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_events_page',
						payload: {
							index: 1,
							limit: 5,
							page_action_name: 'events-init-topiclist'
						}
					});
				})
			);
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台'
					});
					_track({
						trackName: 'toutu_events_page',
						payload: {
							page_action_name: 'events-init-wxconfig'
						}
					});
				})
			);
		} else if (effectFlag === 1 && cache) {
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 0
				// ... more custom settings?
			});
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
		}
	}, [dispatch, effectFlag, props, cache, sportList]);
	return (
		<div className="copyright copyright-events">
			<div className="gallery-top-nav">
				<div className="header-events">
					<div className="search-input">
						<Icon className="search-icon" type="search" size="sm"></Icon>
						<InputItem
							className="search-inner"
							placeholder="搜索图片、视频、活动"
							onFocus={() => {
								history.push({ pathname: '/vpmobile/copyright/search/2' });
							}}></InputItem>
					</div>
				</div>
			</div>
			<Tloader
				initializing={2}
				onRefresh={handleRefresh}
				hasMore={true}
				onLoadMore={handleLoadMore}
				autoLoadMore={pageIndex * pageSize < totalCount /*false不会触发onLoadMore*/}
				className="tloader some class">
				<section className="header-image">
					<ul>
						{get(sportList, 'length', '') &&
							sportList.map((item = {}, index) => (
								<li key={'home-sport-' + index}>
									<div to={'/vpmobile/copyright/activity/' + item.id + '?' + item.id} onClick={toActivity.bind(this, item)}>
										<div className="item-box">
											<img alt="" className="cover lazy" data-src={item.url} />
											<h3>
												<span className="iconfont topic"></span>
												{item.name}
											</h3>
											<p className="des">{remainDaysTip(moment(item.endTime))}</p>
											{item.endTime > new Date().getTime() ? <div className="button">立即参与</div> : <div className="button over">活动已结束</div>}
											<ActTypeIcon item={item} />
										</div>
									</div>
								</li>
							))}
					</ul>
					{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">---- 我是底线，不能更低了 ----</div>}
				</section>
			</Tloader>
			<VBottomNav activeName="events" />
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
		</div>
	);
}
export { CopyrightEvents };
